import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  expiredRewardsData: [],
  error: "",
  success: false,
  status: "",
};

const fetchExpiredRewards = createAsyncThunk(
  "fetch/expired-rewards",
  async ({ status }) => {

    const mobile = localStorage.getItem("mobile");
    try {
      const result = await axios.get(
        `https://apac.api.capillarytech.com/mobile/v2/api/get/marvel/vouchers?mobile=${mobile}&cap_brand=${process.env.REACT_APP_BRAND}&status=${status}&till_id=${process.env.REACT_APP_TILL_ID}`
      );
      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const expiredRewardsSlice = createSlice({
  name: "expired-rewards",
  initialState,
  reducers: {
    resetData: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
      state.expiredRewardsData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExpiredRewards.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchExpiredRewards.fulfilled, (state, action) => {
      // console.log(action.payload, "action payload active rewards");
      state.loading = false;
      state.expiredRewardsData = action?.payload?.userVouchers;
      state.success = action?.payload?.status?.success;
      state.error = "";
    });
    builder.addCase(fetchExpiredRewards.rejected, (state, action) => {
      state.loading = false;
      state.expiredRewardsData = [];
      state.error = action.error.message;
    });
  },
});

export default expiredRewardsSlice.reducer;
export const { resetData } = expiredRewardsSlice.actions;
export { fetchExpiredRewards };
